import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard       = lazy(() => import('../../container/ranking/Index'));
const RankingStoreDetails       = lazy(() => import('../../container/ranking/RankingStoreDetails'));

function RankingRoutes() {
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>  
            }
        >
            <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="store-details" element={<RankingStoreDetails />} />
                <Route path="*" element={<Navigate to="/asm/ranking/dashboard" replace />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(RankingRoutes);
